export const API_BASE_URL = 
  process.env.REACT_APP_API_BASE_URL || 
  "https://api.fsoverflow.io.vn";

export const ENDPOINTS = {
  RSVP: `${API_BASE_URL}/api/rsvp`,
  WISH: `${API_BASE_URL}/api/wish`
};
